import { jsxs, jsx } from 'react/jsx-runtime';
import Badge from '../Badge/Badge.js';
import { Types, isOperazioneWithTextCollapsed, StatoOperazione } from './SnackbarUtils.js';
import ErroreIcon from '../Icons/ErroreIcon.js';
import SuccessoIcon from '../Icons/SuccessoIcon.js';
import Spinner from '../Spinner/Spinner.js';
import Button from '../Button/Button.js';

const printActionText = (operazione) => {
    if (operazione.type === Types.MASSIVA
        || (isOperazioneWithTextCollapsed(operazione))) {
        return 'VEDI';
    }
    return 'OK';
};
const multipleMessages = (operazione) => Array.isArray(operazione.message)
    && operazione.message.length > 1;
const printOperationHeaderMessage = (operazione) => {
    if (operazione.type === Types.MASSIVA) {
        if (operazione.stato === StatoOperazione.PENDING) {
            return 'Elaborazione in corso...';
        }
        if (operazione.stato === StatoOperazione.COMPLETED) {
            return 'Elaborazione terminata';
        }
    }
    else {
        if (Array.isArray(operazione.message)) {
            return `${operazione.message[0]}...`;
        }
        return operazione.message;
    }
    return null;
};
const printIconFromType = (operazione) => {
    var _a;
    if (operazione.type === Types.ERROR) {
        return jsx(ErroreIcon, { className: "icon snackbar__iconError" });
    }
    if (operazione.type === Types.SUCCESS) {
        return jsx(SuccessoIcon, { className: "icon snackbar__iconSuccess" });
    }
    if (operazione.type === Types.WARNING) {
        return jsx(ErroreIcon, { className: "icon snackbar__iconWarning" });
    }
    if (operazione.type === Types.MASSIVA
        && !(operazione.stato === StatoOperazione.COMPLETED)) {
        return jsx(Spinner, { small: true });
    }
    if (operazione.type === Types.MASSIVA && operazione.stato === StatoOperazione.COMPLETED) {
        if (((_a = operazione.errori) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            return jsx(SuccessoIcon, { className: "icon snackbar__iconSuccess" });
        }
        return jsx(ErroreIcon, { className: "icon snackbar__iconWarning" });
    }
    return null;
};
const HeaderOperazione = ({ className = '', expanded = false, onOperazioneBtnClick, operazione, }) => (jsxs("div", { className: className, children: [jsx("div", { className: "snackbar__iconWrapper", children: printIconFromType(operazione) }), jsx("p", { className: "snackbar__title", children: printOperationHeaderMessage(operazione) }), !expanded && multipleMessages(operazione) && (jsx(Badge, { alarm: true, className: "snackbar__multipleMessagesCount", children: operazione.message.length })), jsx("div", { className: "snackbar__actionsContainer", children: ((operazione.type === Types.MASSIVA)
                || (isOperazioneWithTextCollapsed(operazione) && operazione.confirm)) && (jsx(Button, { className: "snackbar__removeBtn", onClick: (e) => onOperazioneBtnClick(e, operazione), primary: true, text: true, children: printActionText(operazione) })) })] }));

export { HeaderOperazione as default, printIconFromType };
